<template>
	<div>
		<p data-cy="appointment-type-label-visitor-page" class="v-label appointment-type-label">{{showDropdown == true ? getLocaleText('appointmentType.dropdownTitle', 'Choose appointment type') : getLocaleText('appointmentType.listTitle', 'How long do you need?')}}</p>
		
		<!-- Showing Appointments Dropdown if appointments have names-->
		<div v-if="showDropdown">
			<v-select 
				data-cy="appointment-dropdown"
				class="appointment-dropdown appointment-dropdown-mobile-view"
				:clearable="false"
				@input="setAppointment"
				:value="selectedAppointment"
				:options="appointmentOptions"
			></v-select>
		</div>
		
		<!-- Else Showing list of time slots for appointments without names -->
		<div 
			v-else 
			class="flex items-center justify-start mt-2 appointment-list"
			:class="{'flex-wrap': calendarData.appointments.length > 4}"
			data-cy="appointment-list"
		>
			<div
				v-for="(appointment, index) in calendarData.appointments" 
				:key="index" 
				class="appointment-list-item"
				:class="[ (calendarData.appointments.length <= 4) ? 'w-full mr-1' : 'w-1/4 mr-2']"
				data-cy="appointment-list-item"
			>
				<div 
					class="w-full p-1 cursor-pointer text-center border-2 flex items-center justify-center"
					:class="[selectedAppointment.id == appointment.id ? 'border-blue-300 selected' : 'border-gray-400']"
					@click=setAppointment(appointment)
				>
					{{appointment.duration}} <span class="minutes">{{getLocaleText("minutes", "minutes")}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {localization} from "../../mixins/localization.js"
import { mapGetters, mapMutations } from "vuex"
import calendarViewSpecific from "../../mixins/calendarViewSpecific.js"

export default {
	name: 'AppointmentTypePicker',
	props: ['showDropdown'],
	mixins: [calendarViewSpecific, localization],

	computed: {
		...mapGetters([
			'calendarData',
			'brandingData',
			'selectedAppointment',
		]),
	},

	methods: {
		...mapMutations([
			'setSelectedAppointment',
			'setIsSlotAvailable',
			'setIsBookingAvailable'
		])
	}
}
</script>

<style>
	.appointment-list-item {
		margin-bottom: .5rem;
	}

	.appointment-dropdown .vs__selected {
		white-space: nowrap;
		max-width: 300px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: inline-block;
		margin: 6px 4px 0px 6px;
	}

	@media(max-width: 375px) {
		.appointment-dropdown .vs__selected {
			max-width: 19rem !important;
		}
	}

	@media(max-width: 480px) {
		.appointment-dropdown .vs__selected {
			max-width: 22rem;
		}

		.appointment-dropdown-mobile-view {
			margin-left: .75rem !important;
			margin-right: .75rem !important;
		}

		.appointment-type-label {
			margin-left: .75rem;
		}

		.appointment-list-item {
			margin-bottom: 0;
		}

		.appointment-list {
			margin-left: .75rem;
			margin-right: .5rem;
		}
	}
</style>

